<template>
  <div class="container h-100 order-container" style="background-color: #fff;">
    <div class="content" style="display: flex;flex-direction: column">
      <div ref="header" class="header">
        <el-row>
          <el-col :span="24">
            <!--            筛选添加 -->
            <AdOrderSearchForm :query-params.sync="searchCondition" @handleQuery="handleQuery"
                               default-time-query :pure-live="pureLive">
              <div style="margin-left: 10px;display: inline">
                <el-link type="primary" @click="pageJump('ad-account')"
                         style="margin-right:10px;max-width: 200px"
                         size="mini"
                         v-if="userAuth.ad_account_list">
                  <i class="el-icon-document"></i>回款记录
                </el-link>
                <el-link type="primary" @click="pageJump('ad-contract')"
                         style="margin-right:10px;max-width: 200px"
                         size="mini"
                         v-if="userAuth.contract_list">
                  <i class="el-icon-document"></i>合同记录
                </el-link>
                <el-link type="primary" @click="pageJump('WorkbenchContract')"
                         style="margin-right:10px;max-width: 200px">
                  <i class="el-icon-document"/>合同工作台
                </el-link>
              </div>
            </AdOrderSearchForm>
          </el-col>
        </el-row>
        <div ref="tools-bar" class="tools-bar">
          <el-badge :value="pageSelectedList.length" style="margin-right: 10px">
            <el-button @click="showPreview" size="mini"><i class="el-icon-shopping-cart-full"></i>预览数据
            </el-button>
          </el-badge>
          <div style="display: inline">
            <el-button @click="handleAdd" class="d-flex-row funcbars-button el-button--operation"
                       v-permission="'can_create_adv_order'" size="mini" style="margin-right: 10px">
              <i class="el-icon-plus"/>新增订单
            </el-button>
          </div>
          <!--                    订单导入-->
          <AdImportOpt @imported="getOrdersList"/>
          <!--          申请开票-->
          <ApplyInvoiceOpt :data-list="pageSelectedList" @applied="afterDeal"/>
          <!--          标记开票-->
          <mark-order-invoice-opt :data-list="pageSelectedList" @marked="afterDeal"/>
          <!--          标记返点-->
          <mark-order-rebate :selection="pageSelectedList" @success="afterDeal"/>
          <!--          核对返点-->
          <verify-order-rebate :selection="pageSelectedList" @success="afterDeal"/>
          <!--          回款记录-操作按钮和交互窗口-->
          <AdPayRecordOpt :data-list="pageSelectedList" :pay_methods="pay_methods" @saveSuccess="afterDeal"/>
          <!--          合同归档-->
          <AdContractOpt :data-list="pageSelectedList" @afterContract="afterDeal"/>
          <!--          发票号码-->
          <adInvoicNumber :data-list="pageSelectedList" @afterInvoic="afterDeal"/>
          <!--          列设置-->
          <set-tbl-columns @success="$refs['refTableAdOrder'].getTableThead()"/>
          <el-button v-if="userAuth.can_set_team" :disabled="selectedOrders.length===0"
                     @click="handelSetOrganization"
                     size="mini">
            分配小组
          </el-button>
          <el-button v-if="userAuth.can_order_year_frame" :disabled="selectedOrders.length===0"
                     @click="handelSetYearFrame"
                     size="mini">
            设置年框
          </el-button>
          <div style="display: inline;margin-left: 10px;">
            <el-button type="danger" :disabled="selectedOrders.length===0"
                       @click="deleteSelected" style="margin-right:10px;" size="mini" icon="el-icon-delete">
              删除
            </el-button>
          </div>
          <div style="display: inline;margin-right: 10px">
            <export-btn :lint-title="`下载模板`" :can-export="true" ref="refExportTempBtn"
                        @export="downloadTemplate('refExportTempBtn')" @click="downloadTemplate"
                        size="mini"></export-btn>
          </div>
          <div style="display: inline;margin-right: 10px">
            <el-button icon="el-icon-folder-opened" size="mini" @click="handleRecycleBin">回收站</el-button>
          </div>

          <div style="display: inline">
            <TempOrderView :tmp-order-num="10"/>
          </div>
        </div>
      </div>
      <!--    广告订单列表表格  -->
      <div class="tableCon" ref="tblDiv">
        <AdOrderTable ref="refTableAdOrder"
                      :query-params.sync="searchCondition"
                      :height="height"
                      :pt="pt"
                      @refreshOrderList="getOrdersList"
                      @handleSelectionChange="handleSelectionChange"
                      @goDetail="goDetail" @tableColumns="tableColumns" :selected-data.sync="pageSelectedList"
                      @clearData="clearData">
        </AdOrderTable>
      </div>
    </div>

    <!--    数据预览-->
    <preview-list ref="refPreview" :columns="currentColumns"
                  :visible.sync="showPreviewDetail"
                  :preview-data="pageSelectedList"
                  no-listener-class="options-button"
                  @hideView="showPreviewDetail = false"
                  @clearData="clearData" @removeSelectedRows="removeSelectedRows"
                  @refresh="refreshList"
                  :pay_methods="pay_methods"
    />

    <distribute-organization :show.sync="showDistributeOri" :orders="selectedOrders" @success="refreshList"/>
    <dialog-year-frame :show.sync="showYearFrame" :orders="selectedOrders" @success="refreshList"/>
    <dialog-recycle-bin :show.sync="showRecycleBin" />
  </div>
</template>
<script>
import PreviewList from '@/views/adOrder/components/PreviewList'
import {getOptionsForSelect} from "@/api/option";
import {getOrdersDestroy} from "@/api/adOrder";
// 全局方法

import {downloadOrderTemplate} from "@/api/order";
import AdOrderSearchForm from "./components/SearchForm";
import AdOrderTable from "@/views/adOrder/components/AdOrderTable";
import AdPayRecordOpt from "@/views/adOrder/components/AdPayRecordOpt";
import adInvoicNumber from "@/views/adOrder/components/adInvoicNumber";
import AdContractOpt from "@/views/adOrder/components/AdContractOpt";
import ApplyInvoiceOpt from "@/views/adOrder/components/ApplyInvoiceOpt";
import MarkOrderInvoiceOpt from "@/views/adOrder/components/MarkOrderInvoiceOpt";
import TempOrderView from "@/views/adOrder/components/TempOrderView";
import DistributeOrganization from "../components/DistributeOrganization";
import AdImportOpt from "@/views/adOrder/components/AdImportOpt.vue";
import ExportBtn from "@/components/export/ExportBtn.vue";
import DialogYearFrame from "@/views/adOrder/components/DialogYearFrame.vue";
import DialogRecycleBin from "@/views/adOrder/order/components/DialogRecycleBin";
import MarkOrderRebate from "@/views/adOrder/components/MarkRebate.vue";
import SetTblColumns from "../components/SetTblColumns.vue";
import VerifyOrderRebate from "@/views/adOrder/components/VerifyRebate.vue";

export default {
  name: "adOrderIndex",
  components: {
    VerifyOrderRebate,
    SetTblColumns,
    MarkOrderRebate,
    DialogYearFrame,
    DialogRecycleBin,
    ExportBtn,
    AdImportOpt,
    // ExportBtn,
    TempOrderView,
    AdOrderTable,
    AdOrderSearchForm,
    DistributeOrganization,
    PreviewList,
    AdPayRecordOpt,
    AdContractOpt,
    ApplyInvoiceOpt,
    MarkOrderInvoiceOpt,
    adInvoicNumber
  },
  props: {
    pureLive: Boolean, // 纯直播
    pt: Number, // 操作类型；1：普通订单，2：全案营销，3：普客打包，4：年框大全案，5：纯直播
  },
  data() {
    return {
      selectedOrders: [],//选中的订单
      showPreviewDetail: false,//数据预览是否展开
      pageSelectedList: [],//预览数据列表
      currentColumns: [],
      columnsFixed: ['customer_name'],//固定字段
      exportLoading: false,
      dialogContract: false,//合同弹窗状态
      orderContractList: [],//订单合同信息列表
      uploadLoading: false,
      isMoreQueryShow: false,
      showDistributeOri: false,
      showYearFrame: false,
      showRecycleBin: false,
      executors: [], //执行人列表
      saleOption: [], //执行人列表
      customerOption: [],
      artistOption: [],
      selectedOptions: [],
      optionsItem: ["pay_methods"],
      order_source: [],
      pay_methods: {},
      searchCondition: {
        time_type: 'created_timestamp',
        timeRange: [],
        orderBy: '`id` desc',
        agent_name: null,
        brand: null,
        company_id: null,
        form_of_cooperation: this.pureLive ? '纯直播' : null,
        order_type: null,
        bool_undo: 0,
        contract_no: null,
        contract_filed: null,
        customer_id: [],
        order_no: [],
        order_nos: '',
        oth_order_no: [],
        oth_order_nos: '',
        is_lb: [],
        is_trailer: [],
        pay_status: [],
        invoice_status: [],
        sale_id: [],
        platform: [],
        order_source: [],
        artist_id: [],
        bool_exec: [],
        is_mark_invoiced: null,
        is_mark_rebate: null,
        is_verify_rebate: null,
        is_can_invoice: null,
        is_new_customer: null,
        bool_covenant: null,
        invoice_number: null,
        is_done_invoice: null,
        back_money_way: null,
        is_quantity: null,
        customer_nature: null,
        trade: null,
        exec_customer_id: [],
      },
      selectList: [],
      tableButtonsWidth: '100px',
      tmpOrderNum: 0,
      topHeight: 0,
      isPreExecutor: 0,
    };
  },
  computed: {
    height() {
      // return 800
      return window.screen.height - this.topHeight - 50
      // return '100%'
    },
    userAuth() {

      return this.$store.getters.getUserAuth;
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  created() {
    this.getOptions(this.optionsItem);
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedOrders = val
      this.addPreview()
    },
    //列表查询
    handleQuery() {
      this.$nextTick(() => {
        this.$refs['refTableAdOrder'].init()
      })
    },
    getOptions(options) {
      getOptionsForSelect(options).then(res => {
        this.pay_methods = res.model.pay_methods || [];
      });
    },
    handleAdd() {
      const {href} = this.$router.resolve({
        name: `createAdOrder`,
        query: {
          type: "add",
          kind: this.pureLive ? 'PureLiveOrder' : 'RegularOrder',
          isPreExecutor: this.isPreExecutor,
          isPureLive: this.pureLive,
          pt: this.pt,
        }
      });
      window.open(href, "_blank");
    },
    goDetail(row) {
      //详情页面，修改页面
      this.editPage(row.id)
    },
    tableColumns(val) {
      this.currentColumns = val
    },
    async setDeleteRow() {
      let _idList = [];
      for (let index = 0; index < this.selectList.length; index++) {
        _idList.push(this.selectList[index].id);
      }

      const response = await getOrdersDestroy({ids: _idList});
      if (!response.success) {
        this.$notify.warning({title: '提示', message: response.message});
        return false
      }
      this.showToast({
        h: this,
        icon: "el-icon-success",
        text: "删除成功",
        duration: 2000
      });
      this.getOrdersList();
    },
    deleteSelected() {
      let that = this;
      let list = this.getSelectRows()
      this.showModal({
        h: this,
        text: `确定删除选中的【${list.length}】条数据？`,
        confirmText: "",
        cancelText: "",
        confirm: function () {
          that.selectList = list;
          that.setDeleteRow();
        },
        cancel: function () {
          // console.log("cancel");
        }
      });
    },
    afterDeal() {
      this.clearData()
      this.getOrdersList()
    },
    //加载订单列表
    getOrdersList() {
      this.$refs['refTableAdOrder'].initList()
    },

    editPage(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        query: {pt: this.pt},
        params: {id: id},
      });
      window.open(href, "_blank");
    },

    //选中行数据集合
    getSelectRows() {
      return this.selectedOrders
    },

    pageJump(routeName) {
      const {href} = this.$router.resolve({
        name: routeName
      });
      window.open(href, "_blank");
    },
    async downloadTemplate(refName) {
      try {
        let name = '订单导入模板'
        const response = await downloadOrderTemplate().then(response => {
          return response
        })
        this.$refs[refName].exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    //刷新订单列表
    refreshList() {
      this.getOrdersList()
    },
    //预览数据添加
    addPreview() {
      if (this.selectedOrders.length > 0) {
        this.selectedOrders.forEach((row) => {
          const currentIdIndex = this.pageSelectedList.findIndex(value => value.id === row.id)
          if (currentIdIndex === -1) {
            this.pageSelectedList.push({...row})
          }
        })
      }
    },
    showPreview() {
      this.showPreviewDetail = true
    },
    //预览数据-清空
    clearData() {
      this.pageSelectedList = []
      this.$refs['refTableAdOrder'].handleClearSelection()
    },
    //预览数据-移除多行
    removeSelectedRows(rows) {
      rows.forEach((row) => {
        let index = this.pageSelectedList.findIndex(item => item.id === row.id);
        if (index > -1) {
          // this.pageSelectedList.splice(index, 1)
          this.$refs['refTableAdOrder'].handleCancelSelect(row)
        }
      })
    },
    handelSetOrganization() {
      this.showDistributeOri = true
    },
    handelSetYearFrame() {
      this.showYearFrame = true
    },
    handleRecycleBin() {
      this.showRecycleBin = true
    }
  },
  mounted() {
    this.topHeight = this.$refs.tblDiv.offsetHeight
  }
};
</script>
<style lang="scss">
.order-container {

  .header {
    background: #fff;
    /*padding: 0px 30px 0 30px;*/
    border-bottom: 1px solid #F2F2F2;
  }

  .tableCon {
    background: #fff;
    /*padding: 12px 15px 0px 15px;*/
    width: 100%;
  }

  .default-button {
    padding: 5px 8px;
    /*color: rgb(254, 45, 84);*/
    font-size: 14px;
    border: 1px solid rgb(161, 161, 161);
    border-radius: 2px;
    cursor: pointer;
  }

  .tools-bar {
    width: 100%;
    text-align: left !important;
    padding: 10px 0;
    display: flex;
    overflow-x: scroll;
  }


  .funcbars-button {
    padding: 6px 8px !important;
    color: rgb(254, 45, 84);
    font-size: 12px;
    border: 1px solid rgb(254, 45, 84);
    cursor: pointer;
    flex: 1;
    border-radius: 3px;
  }

  .funcbars-button i {
    width: 14px;
    height: 14px;
    font-weight: bold;
    line-height: 1.4;
    margin-right: 5px;
  }

  .funcbars-button i svg {
    width: 100%;
    height: 100%;
    fill: rgb(254, 45, 84);
  }

  .funcbars-button-loadding {
    opacity: 0.5;
  }

  .funcbars-button-loadding i svg {
    animation: circle 2s linear infinite;
  }

  @keyframes circle {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .execution-form-item {
    width: 100%;
    margin-bottom: 16px;
  }

  .execution-form-item span {
    white-space: nowrap;
    margin-right: 16px;
  }

  .execution-content {
    padding: 0px 10%;
    height: 320px;
    overflow-y: auto;
  }

  .execution-content-item {
    /* padding-bottom: 16px; */
  }

  .execution-content-item .date {
    color: rgba(50, 50, 50, 1);
  }

  .execution-content-item .content {
    color: rgba(149, 149, 149, 1);
  }

  .execution-content-item span {
    width: 75px;
    text-align: right;
  }

  .bottom-bar {
    width: 100%;
    text-align: left !important;
    padding: 10px 10px 0 10px;
    display: flex;
    overflow-x: scroll;
    align-items: center;
  }

  .export-btn {
    font-size: 1.2em;
  }
}
</style>
